<template>
  <v-col>
    <v-card outlined>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="6"
            sm="12"
          >
            <v-text-field
              v-model="form.name"
              label="Product Name"
              :error-messages="errors.getMessage('name')"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
            sm="12"
          >
            <v-text-field
              v-model="form.price"
              label="Product Price"
              type="number"
              :error-messages="errors.getMessage('price')"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
            sm="12"
          >
            <wysiwyg v-model="form.description" />
            <span class="error--text">
              {{ errors.getMessage("description") }}
            </span>
          </v-col>
          <v-col
            cols="12"
            md="4"
            sm="12"
          >
            <v-btn
              class="info"
              @click="submitForm"
            >
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- Shopping data table -->
    <shop-table
      :key="index"
      no-search
      url-api="/shop-list"
      :headers="headers"
    >
      <!-- Image -->
      <template v-slot:image="{ item }">
        <v-edit-dialog>
          <v-list-item-avatar>
            <v-img
              :src="'/storage/' + item.image"
              lazy-src="/storage/default_img/no_image.png"
              aspect-ratio="1"
              max-width="50"
              max-height="50"
            />
          </v-list-item-avatar>
          <template v-slot:input>
            <v-file-input
              v-model="upload"
              label="Select File"
              placeholder="Upload Image"
              accept="image/jpg, image/png, image/jpeg"
              :loading="upload !== null"
              @change="uploadItemImage(item)"
            />
          </template>
        </v-edit-dialog>
      </template>
      <!-- end -->

      <!-- Price -->
      <template v-slot:price="{ item }">
        {{ item.price | currency }}
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- Gallery Item remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="editItem(item)"
              v-on="on"
            >
              <v-icon>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <!-- end -->
        <!-- Gallery Item remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="warningItemRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </shop-table>

    <!-- end data table -->

    <!-- Remove warning -->
    <v-dialog
      v-model="ItemRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="ItemRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeItem"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import ShopDataTable from "../common/DataTable.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "shop-table": ShopDataTable,
  },
  data() {
    return {
      isEditing: false,
      upload: null,
      form: {},
      item: {},
      ItemRemoveWarning: false,
      index: 1,

      headers: [
        {
          text: "Added At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "image",
          sortable: true,
          value: "image",
          slot: "image",
        },

        {
          text: "Product Name",
          sortable: false,
          value: "name",
        },
        {
          text: "Product Price",
          sortable: false,
          value: "price",
          slot: "price",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    uploadItemImage(item) {
      if (this.upload !== null) {
        const formData = new FormData();
        formData.append("image", this.upload, this.upload.name);
        window.axios
          .post("/shop-item-image/" + item.id, formData)
          .then((response) => {
            this.$data.index++;
            this.$data.upload = null;
            this.feedback(response.data.message);
          });
      }
    },
    editItem(item) {
      this.$data.form = item;
      this.$data.isEditing = true;
    },
    submitForm() {
      if (this.$data.isEditing) {
        this.updateItem();
      } else {
        this.createNew();
      }
    },
    createNew() {
      window.axios.post("/shop-list", this.$data.form).then((response) => {
        this.$data.index++;
        this.$data.form = {};
        this.feedback(response.data.message);
      });
    },
    updateItem() {
      window.axios
        .patch("/shop-list/" + this.form.id, this.$data.form)
        .then((response) => {
          this.$data.index++;
          this.$data.form = {};
          this.$data.isEditing = false;
          this.feedback(response.data.message);
        });
    },
    removeItem() {
      window.axios
        .delete("/shop-list/" + this.$data.item.id)
        .then((response) => {
          this.ItemRemoveWarning = false;
          this.$data.index++;
          this.feedback(response.data.message);
        });
    },

    warningItemRemove(item) {
      this.$data.item = item;
      this.ItemRemoveWarning = true;
    },
  },
};
</script>
